import { render, staticRenderFns } from "./joinLive.vue?vue&type=template&id=32000dca&scoped=true"
import script from "./joinLive.vue?vue&type=script&lang=js"
export * from "./joinLive.vue?vue&type=script&lang=js"
import style0 from "./joinLive.vue?vue&type=style&index=0&id=32000dca&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32000dca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32000dca')) {
      api.createRecord('32000dca', component.options)
    } else {
      api.reload('32000dca', component.options)
    }
    module.hot.accept("./joinLive.vue?vue&type=template&id=32000dca&scoped=true", function () {
      api.rerender('32000dca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/viewsteacher/courseTrain/joinLive.vue"
export default component.exports